import BaseApi from './BaseApi';

class UserService extends BaseApi {
  constructor() {
    super('/users');
  }

  getUsers() {
    return this.get('');
  }

  getProdUsers() {
    return this.get('/prod');
  }

  createUser(payload) {
    return this.post('', payload);
  }

  updateUser(id, payload) {
    return this.client.put(`/${id}`, payload);
  }

  deleteUser(id) {
    return this.client.delete(`/${id}`);
  }

  async cloneUser(id, payload) {
    return this.client.post(`/${id}/clone`, payload)
  }

  async mergeUser(id, payload) {
    return this.client.post(`/${id}/merge`, payload);
  }

  resetPassword(id) {
    return this.post(`/${id}/reset-password`);
  }
}

export default new UserService();
